import { memo } from "react";

interface VehicleInformationProps {
  vehicles: {
    s_PlateSource_En: string;
    s_PlateLetter1_En: string;
    s_PlateLetter2_En: string;
    s_PlateLetter3_En: string;
    s_PlateNumber: string;
    s_Color: string;
  }[];
}

const VehicleInformation = ({ vehicles }: VehicleInformationProps) => {
  return (
    <div>
      <div className="bg-green-primary text-center border-t border-black py-0.5">
        <span className="text-[10px] text-white font-bold">
          Section 5: Vehicle Information
        </span>
      </div>

      <table className="w-full text-xs">
        <thead>
          <tr className="bg-gray-300">
            <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
              Plate Type
            </th>
            <th className="border-y-[0.2px] border-l-[0.2px] border-black p-1 text-[10px] h-4">
              Plate Letters
            </th>
            <th className="border-[0.2px] border-black p-1 text-[10px] h-4">
              Plate Number
            </th>
            <th className="border-y-[0.2px] border-black p-1 text-[10px] h-4">
              Color
            </th>
          </tr>
        </thead>
        <tbody>
          {vehicles?.map((row, idx) => (
            <tr key={idx}>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.s_PlateSource_En}
              </td>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.s_PlateLetter1_En}{row.s_PlateLetter2_En}{row.s_PlateLetter3_En}
              </td>
              <td className="border-b-[0.2px] border-r-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.s_PlateNumber}
              </td>
              <td className="border-b-[0.2px] border-black p-2 h-6 text-[10px] text-center">
                {row.s_Color}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(VehicleInformation);
